<script setup lang="ts">
  import { computed } from 'vue';

  import type { Task } from '@stuut/api/models';
  import { TaskStatus } from '@stuut/api/models';
  import { Badge } from '@ui/components/badge';
  import type { BadgeVariants } from '@ui/components/badge';

  interface Props {
    badgeSize?: BadgeVariants['size'];
    task: Task;
  }

  const props = defineProps<Props>();

  const badgeVariant = computed(() => {
    switch (props.task?.status) {
      case TaskStatus.OPEN:
        return 'open';
      case TaskStatus.COMPLETED:
        return 'success';
      case TaskStatus.CLOSED:
        return 'secondary';
      case TaskStatus.FAILED:
        return 'error';
      case TaskStatus.ARCHIVED:
        return 'outline';
      case TaskStatus.PROCESSING:
        return 'secondary';
      default:
        return 'outline';
    }
  });
</script>

<template>
  <Badge class="capitalize" :variant="badgeVariant" :size="badgeSize">
    <template v-if="!$slots.custom">{{ task?.status }}</template>
    <slot name="custom" />
  </Badge>
</template>

<style scoped></style>
